import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class UserCustomerReferenceService extends BaseReferenceService {
  constructor() {
    super('UserCustomerReference');
  }
}
